<template>
  <div class="fankuiTips">
    <div class="successIcon">
      <img src="../assets/images/successTijiao.png" alt="" />
    </div>
    <div class="dibuBtn">
      <button @click="goHome">回到首页</button>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import { Dialog } from "vant";
import bridge from "../common/bridge";
export default {
  mounted() {

  },
  methods: {
    goHome() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        bridge.callhandler("goBackHome", (data) => {
          // 处理返回数据
          console.log(data);
        });
      }
      if (isAndroid) {
        var str = JSON.parse(window.ServiceAddrInterface.goBackHome());
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fankuiTips {
  min-height: 100vh;
  padding-top: 7.25rem;
  background-color: #fff;
}
.successIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 16.375rem;
  }
}
.dibuBtn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.875rem;
  padding: 0 2rem;

  button {
    width: 100%;
    height: 5.5rem;
    color: #338989;
    background: #fff;
    border: 1px solid#19A0A0;
    font-size: 2rem;
    border-radius: 2.75rem;
    line-height: 5.5rem;
  }
}
</style>